import { RootState } from 'src/redux/root'
import {
  getMeasuresLib,
  mutationFixedCacheKeys,
  upgradeAndExport,
  upgradesApi,
  uploadBaseUpgradingFile
} from 'src/redux/slices/upgrades/endpoints'

export const selectTemplates = (state: RootState) => state.upgrades.templates
export const hasUpgrades = (state: RootState) =>
  Object.values(selectTemplates(state) ?? {})
    ?.map((obj) => Object.keys(obj).length)
    .reduce((a, b) => a + b, 0) > 0

export const selectTemplateSelection = (state: RootState) => state.upgrades.templateSelection

export const selectTemplateContext = (state: RootState) => {
  if (state.upgrades.templateSelection) {
    return state.upgrades.templates?.[state.upgrades.templateSelection] ?? []
  }
  return []
}

export const selectMeasureContext = (state: RootState) => state.upgrades.measureContext

export const selectActiveCloudContext = (state: RootState) => state.upgrades.cloudContext

export const selectDisabledTabs = (state: RootState) => ({
  upload: false,
  assign: !selectTemplates(state),
  export: !hasUpgrades(state),
})

export const selectActiveFilters = (state: RootState) => state.upgrades.activeFilters

export const isLoading = (state: RootState) => {
  const { isLoading: isLoadingMeasures } = getMeasuresLib.select('')(state)

  const { isLoading: isUploadingFile } = uploadBaseUpgradingFile.select(
    mutationFixedCacheKeys.uploadBaseUpgradingFile,
  )(state)

  const { isLoading: isExporting } = upgradeAndExport.select(
    mutationFixedCacheKeys.upgradeAndExport,
  )(state)

  return state.upgrades.isProcessing || isLoadingMeasures || isUploadingFile || isExporting
}
